import type { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';

import { IconWorkaround } from './IconWorkaround';

type StatusMessageProps = Readonly<{ msgKey: IntlKey; icon?: string; iconWorkaround?: string }>;

export function StatusMessage({ msgKey, icon, iconWorkaround }: StatusMessageProps) {
  return (
    <>
      {icon && <em className="icon icon-md pe-2">{icon}</em>}
      {iconWorkaround && <IconWorkaround missingIconName={iconWorkaround} className="pe-2" />}
      <span className="text-large flex-grow-1 fw-semibold">
        <FormattedMessage id={msgKey} />
      </span>
    </>
  );
}

StatusMessage.displayName = 'StatusMessage';
